/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIOrganization } from './APIOrganization';
import {
    APIOrganizationFromJSON,
    APIOrganizationFromJSONTyped,
    APIOrganizationToJSON,
} from './APIOrganization';

/**
 * 
 * @export
 * @interface APIPaginatedOrganizationList
 */
export interface APIPaginatedOrganizationList {
    /**
     * 
     * @type {number}
     * @memberof APIPaginatedOrganizationList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedOrganizationList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedOrganizationList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<APIOrganization>}
     * @memberof APIPaginatedOrganizationList
     */
    results: Array<APIOrganization>;
}

/**
 * Check if a given object implements the APIPaginatedOrganizationList interface.
 */
export function instanceOfAPIPaginatedOrganizationList(value: object): value is APIPaginatedOrganizationList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function APIPaginatedOrganizationListFromJSON(json: any): APIPaginatedOrganizationList {
    return APIPaginatedOrganizationListFromJSONTyped(json, false);
}

export function APIPaginatedOrganizationListFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPaginatedOrganizationList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(APIOrganizationFromJSON)),
    };
}

export function APIPaginatedOrganizationListToJSON(value?: APIPaginatedOrganizationList | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(APIOrganizationToJSON)),
    };
}

